/**
 * Search normalization shared by the server (stored search column) and the
 * POS (local search): case-folded, ё→е, single spaces. Independent of the
 * database locale.
 */
export function normalizeSearch(text: string): string {
  return text.toLocaleLowerCase('ru-RU').replace(/ё/g, 'е').replace(/\s+/g, ' ').trim();
}

/** Words of a query, normalized. */
export function searchWords(query: string): string[] {
  return normalizeSearch(query).split(' ').filter(Boolean);
}

/** Russian plural form: pluralRu(1, ['чек','чека','чеков']) → 'чек', 5 → 'чеков', 22 → 'чека'. */
export function pluralRu(n: number, forms: [one: string, few: string, many: string]): string {
  const abs = Math.abs(n) % 100;
  const last = abs % 10;
  if (abs > 10 && abs < 20) return forms[2];
  if (last === 1) return forms[0];
  if (last >= 2 && last <= 4) return forms[1];
  return forms[2];
}
